exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".job-recommendation__main[data-v-51d01e02]{height:100%;max-height:230px;overflow:auto}.job-recommendation__job-title[data-v-51d01e02]:hover{color:#296db3!important}", ""]);

// exports
